<template>
    <v-toolbar height="150" color="primary">
        <img :src="logo" width="223" />
    </v-toolbar>
    <v-card width="500" class="ma-auto">
        <v-toolbar color="var(--varv-lisa-2)" title="Teie Kriminaalhooldusportaali sessioon on aegunud!">
        </v-toolbar>
        <v-card-text class="text-center ma-3">
            Turvaliseks väljumiseks tuleb sulgeda brauseri aken!
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn class="mx-3 mb-3" variant="elevated" color="primary" @click="logiValja">
                Välju
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<style scoped></style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Logo } from '@finestmedia/vok'
import { mapActions } from 'pinia';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import router from '@/router'
import { useAmetnikStore } from '@/stores/ametnikStore';
import { useTeavitusedStore } from '@/stores/teavitusedStore';
import { useTegevusedStore } from '@/stores/tegevusedStore';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';

export default defineComponent({
    name: 'SessioonAegunudLeht',
    methods: {
        ...mapActions(useKasutajaStore, ['eemaldaKasutaja']),
        ...mapActions(useAmetnikStore, ['eemaldaAmetnik']),
        ...mapActions(useTeavitusedStore, ['eemaldaTeavitused']),
        ...mapActions(useTegevusedStore, ['eemaldaTegevused']),
        ...mapActions(useUldkasulikTooStore, ['eemaldaUldkasulikToo']),

        logiValja() {
            this.eemaldaKasutaja();
            this.eemaldaAmetnik();
            this.eemaldaTeavitused();
            this.eemaldaTegevused();
            this.eemaldaUldkasulikToo();
            router.push({ name: 'MaandumisLeht' })
        }
    },
    data() {
        return {
            logo: Logo
        };
    }
});
</script>